import { WorkflowNodeId, WorkflowVersionId } from '@ply-io/ply-front-shared-utilities';

import { widgetNodeId, widgetWorkflowVersionId, widgetId } from '@/store/modules/widgetEditor/getters';
import { useStore } from '@/utils/store';

export const useWidgetEditorGetters = () => {
	const { getter } = useStore();
	return {
		widgetNodeId: getter<WorkflowNodeId | null>(widgetNodeId),
		widgetWorkflowVersionId: getter<WorkflowVersionId | null>(widgetWorkflowVersionId),
		widgetId: getter<string | null>(widgetId),
	};
};
